export function createNewPathForLocationSlug(href: string, locationSlug: string) {
    const url = new URL(href)
    url.searchParams.delete("umkreis")

    const urlParts = url.pathname.split("/")

    if (urlParts[1] === "sex-anzeigen") {
        // /sex-anzeigen/...
        urlParts.unshift(locationSlug)
    } else if (urlParts[2] === "sex-anzeigen" || urlParts[1]) {
        // /berlin/sex-anzeigen/..
        // /frankfurt-main
        urlParts[1] = locationSlug
    } else {
        // /...
        urlParts.unshift(locationSlug, "sex-anzeigen")
    }

    const newPath = urlParts.join("/")
    url.pathname = newPath
    return url.href
}

export function updateUrl(url: string) {
    window.history.pushState({}, "", url)
}
